import { BaseService } from '@/modules/Core/services/BaseService'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type { AxiosResponse } from 'axios'
import type { IAlertAlertas } from '@/modules/Asistencial/interfaces'
import type { IDashboardStatistics } from '@/modules/DemandaInducida/interfaces/IDemandaInducida'
import type { IDemandaInducidaIndicadores } from '@/modules/DemandaInducida/interfaces/IDemandaInducidaAnalitica'

export class DemandaInducidaDashboardService extends BaseService<IAlertAlertas> {
  constructor() {
    super({
      baseUrl: 'induced-demands/dashboard/'
    })
  }
  async getStatistics(
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<IDashboardStatistics>>> {
    return this.http.get<IResponseApi<IDashboardStatistics>>(`/static-by-route`, { params })
  }
}

export class DemandaInducidaAnalyticsService extends BaseService<IDemandaInducidaIndicadores> {
  constructor() {
    super({ baseUrl: 'induced-demands/analytics/' })
  }

  async getIndicators(
    params?: {
      fechaInicio?: string
      fechaFin?: string
      paciente?: string
      coseId?: string | number
      cocuId?: string | number
      deinRefMultiple?: string
    }
  ): Promise<AxiosResponse<IResponseApi<IDemandaInducidaIndicadores>>> {
    return this.http
      .get<IResponseApi<IDemandaInducidaIndicadores>>('/indicators', { params })
      .catch(this.errorHandle)
  }
}
